module.exports = __webpack_public_path__ + "static/media/PowerMill.c76d9b7e.png";